import { useEffect, useState } from "react";
import { isPasskeySupported } from "gsintegrations";

export function usePasskeySupport() {
  const [supported, setSupported] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let mounted = true;

    void isPasskeySupported().then((result) => {
      if (mounted) {
        setSupported(result);
        setChecked(true);
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  return { supported, checked };
}
